import { Address } from '.'
import { countries } from '../../../../../common/countryData'

export const UK_COUNTRY_STRING = 'United Kingdom of Great Britain and Northern Ireland'

const getAddressPart = (part?: string, prefix = ', ') => {
  return part !== undefined && part !== '' ? `${prefix}${part}` : ''
}

export const getCommaSeparatedAddress = (address: Address) => {
  return [
    address.nameOrNumber || address.name,
    getAddressPart(address.line1, ' '),
    getAddressPart(address.line2),
    getAddressPart(address.city),
    getAddressPart(address.postcode),
  ].join('')
}

export const toAddress = (address: Address) => ({
  ...address,
  country: address.country === 'United Kingdom' ? UK_COUNTRY_STRING : address.country,
  countryCodeAlpha2: createCountryCodeAlpha2(address.country),
})

export const createCountryCodeAlpha2 = (country: string) => {
  return country === 'United Kingdom'
    ? 'GB'
    : countries.find(c => c.name === country)?.alpha2 ?? ''
}
